import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Teleport as _Teleport, Transition as _Transition } from "vue"

const _hoisted_1 = { ref: "trigger" }
const _hoisted_2 = {
  key: 0,
  ref: "container",
  class: "popover-container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  "data-popper-arrow": "",
  class: "arrow bg-white shadow-lg"
}, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5" }
const _hoisted_5 = { class: "relative grid gap-3 bg-white lg:grid-cols-1 cursor-pointer py-1" }
const _hoisted_6 = ["id", "href", "onClick"]
const _hoisted_7 = { class: "flex items-center justify-center flex-shrink-0 w-10 h-10 sm:h-12 sm:w-12" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_9 = { class: "text-sm text-gray-400" }
const _hoisted_10 = {
  key: 1,
  class: "bg-gray-200 border border-gray-200 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIIcon = _resolveComponent("UIIcon")!
  const _component_PopoverButton = _resolveComponent("PopoverButton")!
  const _component_CustomIcon = _resolveComponent("CustomIcon")!
  const _component_PopoverPanel = _resolveComponent("PopoverPanel")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createBlock(_component_Popover, { class: "relative" }, {
    default: _withCtx(({ close, open }) => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "popoverButton")
      ], 512 /* NEED_PATCH */),
      (!_ctx.$slots.popoverButton)
        ? (_openBlock(), _createBlock(_component_PopoverButton, {
            key: 0,
            id: "page-email-builder-template__btn-actions",
            class: "max-h-9 border-curious-blue-500 px-2 py-2 leading-5 text-xs inline-flex items-center justify-center rounded transition ease-in-out duration-150 border font-medium text-curious-blue-500 focus:outline-none"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", { ref: "trigger" }, _toDisplayString(_ctx.$t(_ctx.title)), 513 /* TEXT, NEED_PATCH */),
              _createVNode(_component_UIIcon, {
                icon: "heroicons-outline:chevron-down",
                class: "w-4 h-4 ml-2"
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createVNode(_Transition, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
            open
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_PopoverPanel, {
                    static: "",
                    class: "w-96 z-10 max-w-sm px-4 mt-1 transform -translate-x-1/4 sm:px-0 lg:max-w-xl"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionMenuItems, (menuItem, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              id: 
                    !(menuItem.id === _ctx.sepratorId)
                      ? `pg-email-builder-pages-${_ctx.context}__menu_item-
                        ${menuItem.id}`
                      : ''
                  ,
                              key: menuItem.name,
                              href: menuItem.href,
                              onClick: ($event: any) => (_ctx.onActionMenuClick(menuItem, close)),
                              class: _normalizeClass(["flex items-center -m-2 hover:bg-gray-100 transition duration-150 ease-in-out rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50", {
                    'pointer-events-none cursor-none p-0':
                      menuItem.id === _ctx.sepratorId,
                    'px-4 py-2 ': menuItem.id !== _ctx.sepratorId,
                    'pt-4': index === 0,
                    'pb-4': index === _ctx.actionMenuItems.length - 1,
                  }])
                            }, [
                              (menuItem.id !== _ctx.sepratorId)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_component_CustomIcon, {
                                        iconName: menuItem.icon,
                                        className: "w-6 h-6 mr-4"
                                      }, null, 8 /* PROPS */, ["iconName"])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("p", _hoisted_8, _toDisplayString(menuItem.name), 1 /* TEXT */),
                                      _createElementVNode("p", _hoisted_9, _toDisplayString(menuItem.description), 1 /* TEXT */)
                                    ])
                                  ], 64 /* STABLE_FRAGMENT */))
                                : (_openBlock(), _createElementBlock("div", _hoisted_10))
                            ], 10 /* CLASS, PROPS */, _hoisted_6))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ], 512 /* NEED_PATCH */))
              : _createCommentVNode("v-if", true)
          ]))
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */)
    ]),
    _: 3 /* FORWARDED */
  }))
}